import React, { useState, useEffect } from 'react';

/** Home par 🛡️ Admin Panel ka button - sirf admins ko. */
export default function AdminHomeButton({ user }) {
  const [me, setMe] = useState(null);

  useEffect(() => {
    if (!user) return;
    const t = localStorage.getItem('token') || '';
    fetch('/api/admin-panel/whoami/', {
      headers: { 'Content-Type': 'application/json', ...(t ? { Authorization: `Token ${t}` } : {}) },
    })
      .then((r) => (r.ok ? r.json() : null))
      .then((j) => { if (j && j.is_admin) setMe(j); })
      .catch(() => {});
  }, [user]);

  if (!me) return null;

  const scope = me.is_super_admin
    ? 'Super Admin'
    : (me.modules || []).map((m) => m.label).join(' \u00b7 ') || 'Admin';

  return (
    <a href="/admin/panel" style={{
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      margin: '10px 6px 0', padding: '9px 12px', borderRadius: 10,
      background: 'rgba(15,110,86,0.18)', border: '1px solid rgba(52,211,153,0.45)',
      textDecoration: 'none',
    }}>
      <span style={{ fontSize: 12.5, fontWeight: 700, color: '#34d399' }}>
        {'\u{1F6E1}\uFE0F'} Admin Panel
      </span>
      <span style={{ fontSize: 10.5, color: '#94a3b8' }}>
        {scope}{me.acting_as_user ? ' \u00b7 user mode' : ''} {'\u2192'}
      </span>
    </a>
  );
}
